export default __webpack_public_path__ + "static/media/water-3.a94172c3.jpg";